import { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { Company } from "store/environments/tenants/companies/companies-types";

export const loadCompanies = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[Company[] | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/companies`,
        {
            cancelToken: cancelTokenSource?.token,
        }
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
